import * as React from 'react';
import { FunctionComponent } from 'react';
import { Alert } from '@iba-team/portal-react-components/dist';
import { useTranslation } from 'react-i18next';
import './InvalidReportAlert.scss';

interface InvalidReportAlertProps {
  users: string[]
}

const InvalidReportAlert: FunctionComponent<InvalidReportAlertProps> = ({users}) => {
  const { t } = useTranslation();

  return (
    <>
      { (users.length > 0)
        ?
        <Alert type='warning' className='invalidReportAlert'>
          <div dangerouslySetInnerHTML={{ __html: t('messagesForBanners.incompleteReport.message', {data: users.join(', ')}) }}></div>
        </Alert>
        :
        null
      }
    </>
  );
};

export default InvalidReportAlert;